'use strict';

/* eslint no-undef: "off" */
define('confirmDialog',[], function () {
  return {
    template: '\n      <modal\n        :name="name"\n        :width="width"\n        height="auto"\n        :transition="transition"\n        :delay="delay"\n        :classes="mergedModalClass"\n      >\n        <div class="xp-shared-confirm-dialog" :class="dialogClass">\n          <div class="xp-shared-confirm-dialog__copy">\n            <h3 v-if="title" v-text="title"></h3>\n            <p v-if="message" v-text="message"></p>\n          </div>\n          <div\n            class="xp-shared-confirm-dialog__actions"\n            :class="{\'is-single\': normalizedButtons.length === 1}"\n            v-if="normalizedButtons.length"\n          >\n            <button\n              v-for="button in normalizedButtons"\n              :key="button.action"\n              type="button"\n              class="xp-shared-confirm-dialog__button"\n              :class="\'is-\' + button.type"\n              v-text="button.text"\n              @click.prevent="$emit(\'action\', button.action)"\n            ></button>\n          </div>\n        </div>\n      </modal>\n    ',
    props: {
      name: {
        type: String,
        default: 'confirmDialog'
      },
      title: {
        type: String,
        default: ''
      },
      message: {
        type: String,
        default: ''
      },
      buttons: {
        type: Array,
        default: function _default() {
          return [];
        }
      },
      dialogClass: {
        type: [String, Object, Array],
        default: ''
      },
      modalClass: {
        type: [String, Object, Array],
        default: ''
      },
      width: {
        type: [String, Number],
        default: '100%'
      },
      transition: {
        type: String,
        default: 'overlay-fade'
      },
      delay: {
        type: Number,
        default: 10
      }
    },
    computed: {
      mergedModalClass: function mergedModalClass() {
        return ['xp-shared-confirm-dialog-modal', this.modalClass].filter(Boolean);
      },
      normalizedButtons: function normalizedButtons() {
        return this.buttons.map(function (button, index) {
          return {
            text: button.text || '',
            action: button.action || 'action-' + index,
            type: button.type || (index === 0 ? 'secondary' : 'primary')
          };
        });
      }
    }
  };
});
